import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const SuperOptimizeIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 21 21" fill="none">
      <path
        d="M6.5025 3.59707L4.0025 4.99707L5.4025 2.49707L4.0025 -0.00292969L6.5025 1.39707L9.0025 -0.00292969L7.6025 2.49707L9.0025 4.99707L6.5025 3.59707ZM18.5025 13.3971L21.0025 11.9971L19.6025 14.4971L21.0025 16.9971L18.5025 15.5971L16.0025 16.9971L17.4025 14.4971L16.0025 11.9971L18.5025 13.3971ZM21.0025 -0.00292969L19.6025 2.49707L21.0025 4.99707L18.5025 3.59707L16.0025 4.99707L17.4025 2.49707L16.0025 -0.00292969L18.5025 1.39707L21.0025 -0.00292969ZM12.3425 10.7771L14.7825 8.33707L12.6625 6.21707L10.2225 8.65707L12.3425 10.7771ZM13.3725 5.28707L15.7125 7.62707C16.1025 7.99707 16.1025 8.64707 15.7125 9.03707L4.0425 20.7071C3.6525 21.0971 3.0025 21.0971 2.6325 20.7071L0.2925 18.3671C-0.0975 17.9971 -0.0975 17.3471 0.2925 16.9571L11.9625 5.28707C12.3525 4.89707 13.0025 4.89707 13.3725 5.28707Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default SuperOptimizeIcon;
